import { BonificoOrderDTO } from "../../../ProductService/BonificoOrder/BonificoOrderDTO.ts";
import { formatDateRome } from "../../../UI/Utils/formatDateRome.ts";

function describeDraft(draft: BonificoOrderDTO): string {
  const valueDate = draft.valueDateUtc
    ? ` · data valuta ${formatDateRome(draft.valueDateUtc, "DD/MM/YYYY")}`
    : "";
  return `Bozza del ${formatDateRome(draft.createdAt)} · ${draft.customer.firstName} ${draft.customer.lastName} · ID ${draft.orderId}${valueDate}`;
}

function DraftOption({
  label,
  isChosen,
  onChoose,
}: {
  label: string;
  isChosen: boolean;
  onChoose: () => void;
}) {
  return (
    <label className="flex items-start gap-2 text-gray-700">
      <input
        type="radio"
        name="bonificoDraft"
        checked={isChosen}
        onChange={onChoose}
        className="mt-0.5 w-4 h-4 shrink-0 accent-primary"
      />
      <span className="break-words">{label}</span>
    </label>
  );
}

export function CustomerDraftChoice({
  drafts,
  chosenDraft,
  onChoose,
}: {
  drafts: BonificoOrderDTO[];
  chosenDraft?: BonificoOrderDTO;
  onChoose: (draft?: BonificoOrderDTO) => void;
}) {
  return (
    <div
      role="radiogroup"
      aria-label="Bozza bonifico del cliente"
      className="flex flex-col gap-2 rounded-lg border border-indigo-200 bg-indigo-50 p-3 text-sm"
    >
      <p className="font-medium text-indigo-900">
        {drafts.length === 1
          ? "Il cliente ha una bozza bonifico da completare"
          : `Il cliente ha ${drafts.length} bozze bonifico da completare`}
      </p>
      <p className="text-xs text-indigo-800">
        I dati di fatturazione sono precompilati dalla bozza scelta. Registrando
        il saldo, la bozza viene confermata come saldo rate, senza creare un
        nuovo ordine bonifico.
      </p>
      {drafts.map((draft) => (
        <DraftOption
          key={draft.orderId}
          label={describeDraft(draft)}
          isChosen={chosenDraft?.orderId === draft.orderId}
          onChoose={() => onChoose(draft)}
        />
      ))}
      <DraftOption
        label="Non usare la bozza: dati di fatturazione dell'ordine Stripe e nuovo ordine bonifico"
        isChosen={!chosenDraft}
        onChoose={() => onChoose(undefined)}
      />
    </div>
  );
}
